// index.tsx
import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { DatatableProps } from "../../data/interface";


const Datatable: React.FC<DatatableProps> = ({ columns, dataSource , Selection, pagination, onChange }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [Selections, setSelections] = useState<any>(true);
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource);

  useEffect(() => {
    setFilteredDataSource(dataSource);
  }, [dataSource]);

  const onSelectChange = (newSelectedRowKeys: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    const filteredData = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDataSource(filteredData);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  useEffect(() => {
    return setSelections(Selection);
  }, [Selection])
  
  
  return (
    <>

     <div className="table-top-data">
      <div className="row p-3">
          <div className="col-sm-12 col-md-6">
            <div className="dataTables_length" id="DataTables_Table_0_length">
            </div>
          </div>
          <div className="col-sm-12 col-md-6">
            <div id="DataTables_Table_0_filter" className="dataTables_filter text-end mb-0">
              <label>
                {" "}
                <input
                  type="search"
                  className="form-control form-control-sm"
                  placeholder="Pesquisar"
                  aria-controls="DataTables_Table_0"
                  value={searchText} onChange={(e) => handleSearch(e.target.value)}
                />
              </label>
            </div>
          </div>
        </div>
     </div>

     {!Selections ?
      <Table
      className="table datanew dataTable no-footer"

      style={{
        minHeight: "500px",
        overflow: "visible",
      }}
     
      columns={columns}
      rowHoverable={false}
      dataSource={filteredDataSource}
      onChange={onChange}
      pagination={pagination || {
        locale: { items_per_page: "" },
        nextIcon: <i className="ti ti-chevron-right"/>,
        prevIcon: <i className="ti ti-chevron-left"/>,
        defaultPageSize: 100,
        showSizeChanger: true,
        pageSizeOptions: ["100", "200", "300"],
      }}
    /> : 
    <Table
        className="table datanew dataTable no-footer"

        style={{
          minHeight: "500px",
          overflow: "visible",
        }}

        columns={columns}
        rowHoverable={false}
        dataSource={filteredDataSource}
        onChange={onChange}
        pagination={pagination || {
          locale: { items_per_page: "" },
          nextIcon: <i className="ti ti-chevron-right"/>,
          prevIcon: <i className="ti ti-chevron-left"/>,
          defaultPageSize: 100,
          showSizeChanger: true,
          pageSizeOptions: ["100", "200", "300"],
          showTotal: (total, range) => `Mostrando ${range[0]} - ${range[1]} de ${total} entradas`,
        }}
      />}
      
    </>
  );
};

export default Datatable;
